export type TesterTransactionType = "Facilitation" | "Trading";
export type TesterDispatchMode = "SELF_DISPATCH" | "SELF_PICKUP";
export type TesterDeliveryPreference = "STANDARD" | "INSTANT" | "SELF_PICKUP";
export type EventWaitPolicy = "ask" | "wait" | "skip";

export interface TesterPart {
  partId: string;
  partNumber?: string;
  rootPartNumber?: string;
  partName?: string;
  quantity: number;
  mrp?: number;
}

export interface TesterRider {
  name: string;
  phoneNumber: string;
  vehicleNumber: string;
}

export interface TesterInvoiceDefaults {
  invoiceNoPrefix: string;
  amount: string;
}

export interface TesterConfig {
  customerId: string;
  customerName?: string;
  customerCode?: string;
  customerMobile?: string;
  isTestCustomer?: boolean;

  supplierId: string;
  supplierName?: string;
  supplierMobile?: string;
  isTestSupplier?: boolean;

  shipmentAddressId?: string;
  shipmentAddress?: Record<string, unknown>;
  billingDetails?: Record<string, unknown>;

  parts: TesterPart[];
  orderMediaIds: string[];
  remarks: string;
  carMaker: string;

  /**
   * Enquiry created with requirePriceEstimate: the backend shares a draft
   * estimate after part conversion, and the customer requests the final one.
   * Off = existing flow (straight to FINAL_ESTIMATE_REQUESTED).
   */
  requirePriceEstimate: boolean;

  transactionType: TesterTransactionType;
  payableBy: string;
  payableTo: string;
  /** Which system delivery option to confirm. Standard Delivery is the default. */
  preferredDelivery: TesterDeliveryPreference;
  dispatchMode: TesterDispatchMode;
  rider: TesterRider;
  invoice: TesterInvoiceDefaults;
  cancellationReason: string;

  pollMaxAttempts: number;
  invoiceEventPolicy: EventWaitPolicy;
  deliveredEventPolicy: EventWaitPolicy;
}

export const DEFAULT_TESTER_CONFIG: TesterConfig = {
  customerId: "",
  supplierId: "",
  parts: [],
  orderMediaIds: [],
  remarks: "OrCA E2E flow tester",
  carMaker: "",
  requirePriceEstimate: false,
  transactionType: "Facilitation",
  payableBy: "CUSTOMER",
  payableTo: "SUPPLIER",
  preferredDelivery: "STANDARD",
  dispatchMode: "SELF_DISPATCH",
  rider: {
    name: "Test Rider",
    phoneNumber: "9999999999",
    vehicleNumber: "TS-00-TEST",
  },
  invoice: {
    invoiceNoPrefix: "TST",
    amount: "1000",
  },
  cancellationReason: "E2E tester cancellation",
  pollMaxAttempts: 8,
  invoiceEventPolicy: "ask",
  deliveredEventPolicy: "ask",
};
